/*
 * Copyright (c) 2018
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ReportService} from '../../../services/report.service';
import {Report} from '../../../model/report';

@Injectable()
export class LockService {
  fieldsLocked = new BehaviorSubject<boolean>(true);
  fieldsLocked$ = this.fieldsLocked.asObservable();

  private report: Report;

  constructor(
    private reportService: ReportService
  ) {
    this.reportService.report$.subscribe(report => this.report = report);
  }

  lock(): void {
    this.fieldsLocked.next(true);
  }

  unLock(): void {
    this.fieldsLocked.next(false);
  }

  getLock(field: string): boolean {
    if (this.fieldsLocked.getValue() === false)
      return false;
    else {
      if (this.report.BVQ?.READ_ONLY) {
        if (!this.report.BVQ.READ_ONLY[field])
          return false;
      } else return false;

      return this.report.BVQ.READ_ONLY[field].VALUE;
    }
  }
}
